import styled from '@emotion/styled';
import { StyledDiv } from '../../../../../common/components/styled-div';
import { Typography } from '../../../../../atoms/typography/typography';
import { Select } from '../../../../../atoms/select/select';
import { DateTextField } from '../../../../../molecules/date-text-field/date-text-field';
import { Spacing } from '../../../../../atoms/spacing/spacing';
import { Button } from '../../../../../atoms/button/button';
import { StyledFixedButtonWrapper } from '../../../../../common/components/styled-fixed-button-wrapper/styled-fixed-button-wrapper';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

export interface RmAssignSchoolsCoach {
  id: string;
  name: string;
  assignedSchools: string[];
  onEdit?: () => void;
}

interface RmAssignSchoolsProps {
  coaches: RmAssignSchoolsCoach[];
  onSave: () => void;
  scheduleType: string;
  scheduleTypes: string[];
  onScheduleTypeChange: (type: string) => void;
  startDate?: string;
  endDate?: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  errorMessage?: string;
}

export const RmNewSchedule = ({
  onSave,
  scheduleType,
  scheduleTypes,
  onScheduleTypeChange,
  startDate = '',
  endDate = '',
  onStartDateChange,
  onEndDateChange,
  errorMessage,
}: RmAssignSchoolsProps) => (
  <StyledDiv
    flexDirection="column"
    width="100%"
    padding="0 0 var(--rk-spacing-xxxxxl) 0"
    gap={12}
  >
    <StyledRow>
      <StyledScheduleType>
        <Typography variant="textTitleMedium" textAlign="left">
          Select schedule type
        </Typography>
        <Spacing marginBottom="xl" />
        <Select
          options={scheduleTypes.map((type) => ({
            value: type,
            content: type,
          }))}
          defaultValue={scheduleType}
          onChange={(option) => onScheduleTypeChange(option.value)}
          variant="outlined"
          disabled
          width="100%"
        />
      </StyledScheduleType>

      <Spacing marginBottom="xl" />

      <StyledDiv width="100%" flexDirection="column">
        <Typography variant="textTitleMedium" textAlign="left">
          Select dates for schedule
        </Typography>

        <Spacing marginBottom="xl" />

        <StyledDiv gap={12}>
          <DateTextField
            label="Start Date"
            placeholder="Start Date"
            value={startDate ?? ''}
            onChange={onStartDateChange}
            width="100%"
          />
          <DateTextField
            label="End Date"
            placeholder="End Date"
            value={endDate ?? ''}
            onChange={onEndDateChange}
            width="100%"
          />
        </StyledDiv>
      </StyledDiv>
    </StyledRow>

    {errorMessage && (
      <StyledDiv padding="var(--rk-spacing-m) 0">
        <Typography
          variant="textBodyMediumError"
          textAlign="left"
          color="error"
        >
          {errorMessage}
        </Typography>
      </StyledDiv>
    )}

    <StyledFixedButtonWrapper>
      <Button onClick={onSave}>Next</Button>
    </StyledFixedButtonWrapper>
  </StyledDiv>
);

const StyledScheduleType = styled.div`
  flex-direction: column;
  ${mq(BreakpointSizes.desktop)} {
    width: 40%;
  }
`;

const StyledRow = styled.div`
  ${mq(BreakpointSizes.desktop)} {
    display: flex;
    gap: var(--rk-spacing-xl);
  }
`;
